import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';

// Uncomment to package css transpiled from index.scss into index.css
//import './index.css';
import './shims/polyfills'

import SearchApp from './Components/search/SearchApp';

if (typeof window === 'undefined')
    var window = {};

global.React = React;
global.ReactDOM = ReactDOM;
global.ReactDOMServer = ReactDOMServer

global.Search = SearchApp;